import testCompanyApi from '@/api/testCompany'
import get from 'lodash/get'

const INITIAL_STATE = {
  // entity:{}
}

export default {
  namespace: 'testCompany',

  state: INITIAL_STATE,

  reducers: {
    init() {
      return { ...INITIAL_STATE }
    },
    // setEntity(state, { payload }) {
    //   return { ...state, entity: payload }
    // },
  },

  effects: {
    *create({ payload, successCallback, errorCallback }, { select, call }) {
      // get token from redux that storge in client application data
      const { account } = yield select(state => state.auth)

      try {
        const formData = new FormData()
        formData.append('image', payload.file)
        formData.append('accountId', get(account, 'accountId'))
        formData.append('status', payload.status)
        formData.append('name', payload.name)

        const response = yield call(testCompanyApi.createTestCompany, {
          data: payload,
          params: { accountId: get(account, 'accountId') },
        })

        const { status, data: resData } = response
        if (status === 200 && resData.success === true) {
          successCallback?.()
        } else {
          errorCallback?.()
        }
      } catch (error) {
        console.error('API call error:', error)
        // errorCallback?.(error || 'API call failed')
        errorCallback?.()
      }
    },

    *createNoneFile({ payload, successCallback, errorCallback }, { select, call }) {
      // get token from redux that storge in client application data
      const { account } = yield select(state => state.auth)

      try {
        const formData = new FormData()
        formData.append('accountId', get(account, 'accountId'))
        formData.append('status', payload.status)
        formData.append('name', payload.name)

        const response = yield call(testCompanyApi.createTestCompanyNoneFile, {
          data: payload,
          params: { accountId: get(account, 'accountId') },
        })

        const { status, data: resData } = response
        if (status === 200 && resData.success === true) {
          successCallback?.()
        } else {
          errorCallback?.()
        }
      } catch (error) {
        console.error('API call error:', error)
        // errorCallback?.(error || 'API call failed')
        errorCallback?.()
      }
    },

    *delete({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)

      let error

      const response = yield call(testCompanyApi.deleteTestCompany, {
        ...payload,
        params: { ...payload, accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response

      if (status === 200 && resData.success === true) {
        const { success, message } = resData
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      } else {
        errorCallback?.()
      }

      if (error) {
        console.error('Error occurred:', error)
      }
    },

    *modify({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(testCompanyApi.modifyTestCompany, {
        accountId: get(account, 'accountId'),
        params: { ...payload, accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response

      const hasError = true

      if (status === 200 && resData.success === true) {
        //   hasError = false

        //   yield put({ type: 'company/setDnsRecord', payload: resData.data })

        successCallback?.(resData)
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *select({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)

      let error

      const response = yield call(testCompanyApi.getTestCompany, {
        ...payload,
        params: { ...payload, accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response

      if (status === 200 && resData.success === true) {
        const { success, message } = resData
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      } else {
        errorCallback?.()
      }

      if (error) {
        console.error('Error occurred:', error)
      }
    },

    *selectLogo({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)

      let error

      const response = yield call(testCompanyApi.getTestCompany, {
        ...payload,
        params: { ...payload, accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response

      if (status === 200 && resData.success === true) {
        const { success, message } = resData
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      } else {
        errorCallback?.()
      }

      if (error) {
        console.error('Error occurred:', error)
      }
    },
  },
}
